import { render, staticRenderFns } from "./state.vue?vue&type=template&id=19b460e4&scoped=true&lang=pug&"
import script from "./state.vue?vue&type=script&lang=js&"
export * from "./state.vue?vue&type=script&lang=js&"
import style0 from "./state.vue?vue&type=style&index=0&id=19b460e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b460e4",
  null
  
)

export default component.exports